// extracted by mini-css-extract-plugin
export default {"date-container":"_3_eOD","dateContainer":"_3_eOD"};